import { render, staticRenderFns } from "./ContactFormTable.vue?vue&type=template&id=0150de3a&scoped=true&"
import script from "./ContactFormTable.vue?vue&type=script&lang=js&"
export * from "./ContactFormTable.vue?vue&type=script&lang=js&"
import style0 from "./ContactFormTable.vue?vue&type=style&index=0&id=0150de3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0150de3a",
  null
  
)

export default component.exports